import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const SetoresComFisio = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="SETORES DE ASSISTÊNCIAS QUE POSSUEM FISIOTERAPEUTAS" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Setor" nome="setor" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="56vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Assistência - h/dia" nome="horadia" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        
                    </div>
                    </Caixa >
            )
        }
        return partes
    }
}

export default SetoresComFisio